"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiBadge = void 0;
var typography_1 = require("../../../theme/global/typography");
var palette_1 = require("../../global/palette");
var shape_1 = require("../../global/shape");
exports.MuiBadge = {
    badge: {
        paddingLeft: 5,
        paddingRight: 5,
        paddingTop: 1,
        paddingBottom: 1,
        fontSize: typography_1.typography.pxToRem(10),
        fontWeight: typography_1.typography.fontWeightBold,
        borderRadius: shape_1.shape.borderRadius,
        height: 16,
        minWidth: 15,
    },
    colorError: {
        color: palette_1.palette.common.white,
    },
};
